export default "__VITE_ASSET__DIH4C8im__"